import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FileCopyOutlined } from "@material-ui/icons";
import { Dialog, DialogContent, DialogTitle, Tooltip } from "@material-ui/core";

import { getAppVersion } from "../../config";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    userSelect: "none"
  },

	dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    gap: "1em",
  },

  infoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    gap: "1em",
    width: "100%",
  },

  copyButtonContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
    justifyContent: "center",
    padding: "1em",
  },

  copyButton: {
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": { transform: "translateY(-5px)", }
  },
}));

const VersionModal = ({ open, onClose, applicationVersion }) => {
  //  ***************
  //  ** Variables **
  //  ***************
	const classes = useStyles();
  const timeoutCopyRef = useRef(null);
  const [copyTooltip, setCopyTooltip] = useState(i18n.t("versionModal.tooltips.copy"));
  const versionInfo = applicationVersion.split("_");



  //  ***************
  //  ** Functions **
  //  ***************
	const handleClose = () => {
    onClose();
  };

  const handleCopyInfo = async () => {
    const clipboardInfo = `${i18n.t("versionModal.spans.version")}: ${getAppVersion()}\n${i18n.t("versionModal.spans.group")}: ${versionInfo[0]}\n${i18n.t("versionModal.spans.vps")}: ${versionInfo[1]}\n${i18n.t("versionModal.spans.tenant")}: ${versionInfo[2]}`;
    await navigator.clipboard.writeText(clipboardInfo);

    setCopyTooltip(i18n.t("versionModal.tooltips.copied"));

    if (timeoutCopyRef.current) clearTimeout(timeoutCopyRef.current);
    timeoutCopyRef.current = setTimeout(() => setCopyTooltip(i18n.t("versionModal.tooltips.copy")), 700);
  };



  //  ************
  //  ** Return **
  //  ************
	return (
		<div>
			<Dialog className={classes.root} open={open} onClose={handleClose} scroll="paper">
				<DialogTitle>
          {i18n.t("versionModal.title.up")}
        </DialogTitle>
			
        <DialogContent className={classes.dialogContent} dividers>
          <div className={classes.infoContainer}>
            <span>{i18n.t("versionModal.spans.version")}: <b>{getAppVersion()}</b></span>
            <span>{i18n.t("versionModal.spans.group")}: <b>{versionInfo[0]}</b></span>
            <span>{i18n.t("versionModal.spans.vps")}: <b>{versionInfo[1]}</b></span>
            <span>{i18n.t("versionModal.spans.tenant")}: <b>{versionInfo[2]}</b></span>
          </div>

          <div className={classes.copyButtonContainer}>
            <Tooltip title={copyTooltip} placement="top-start" arrow>
              <span className={classes.copyButton} onClick={async () => await handleCopyInfo()}>
                <FileCopyOutlined />
              </span>
            </Tooltip>
          </div>
        </DialogContent>			
			</Dialog>
		</div>
	);
};

export default VersionModal;
